import i18n from "@/i18n";

const routes = {
  path: "/room",
  name: "Room",
  component: () => import(/* webpackChunkName: "room" */ "@/views/room/Main"),
  children: [
    {
      path: "list",
      alias: "",
      name: "RoomList",
      component: () =>
        import(/* webpackChunkName: "room" */ "@/views/room/List"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("title.simulator.hittingbay"),
        step: [
          i18n.t("menu.simulator.simulator"),
          i18n.t("title.simulator.hittingbay"),
        ],
        menu_num: 3,
        sub_menu_num: 31,
        location: "/room/list",
      },
    },
    {
      path: "round",
      name: "RoomTable",
      component: () =>
        import(/* webpackChunkName: "room" */ "@/views/room/Round"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("title.simulator.game_information"),
        step: [
          i18n.t("menu.simulator.simulator"),
          i18n.t("menu.simulator.game"),
        ],
        menu_num: 3,
        sub_menu_num: 32,
        location: "/room/round",
      },
    },
  ],
};

export default routes;
